export default __webpack_public_path__ + "images/electronics-technician.jpg";